<template>
	<v-card class="elevation-0 events-page page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<div class="categories-page__wrap">
				<div class="d-flex">
					<v-skeleton-loader width="600" v-bind="attrs" type="card" v-if="false">
					</v-skeleton-loader>
					<FeaturedPost v-else />
				</div>
			</div>

			<FilterChipButtons
				:isButtonActive="isButtonActive"
				:chipsList="chipsList"
				:clearFilter="clearFilter"
				@handleChipClick="handleChipClick"
			/>
			<div v-if="filterModalIsVisible">
				<FilterModal
					:filterModalIsVisible="filterModalIsVisible"
					:currentModalFilter="currentModalFilter"
					:currentModalLabel="currentModalLabel"
					:selectedChips="selectedChips"
					:filters="filters"
					@closeModal="closeModal"
					@applySelection="applySelection"
					@setItem="setItem"
				/>
			</div>

			<div
				class="post__fake-btn-modal-container mt-5"
				@click="openCreatePostModal"
				v-if="!this.isLoading"
			>
				<div>
					<Avatar
						class="mr-4 post-preview-card__avatar"
						:size="30"
						:avatar="profile.user_logo"
					/>
					What’s on your mind?
				</div>

				<Icon type="pencil" :size="16" color="#a0a0a0" />
			</div>

			<div class="forums">
				<v-skeleton-loader
					v-if="isLoading"
					v-bind="attrs"
					width="600"
					type="list-item, list-item-three-line, card-heading"
				></v-skeleton-loader>
				<div v-else style="width: 100%">
					<div v-if="this.forumCategories.length === 0" class="mt-5 page-container">
						<NewsFeedEmpty
							title="Your forum categories is empty at the moment."
							description="Check back later."
						/>
					</div>

					<div v-for="(category, index) in forumCategories" :key="index">
						<CategoryCard :category="category" />
					</div>
				</div>
			</div>

			<div
				class="d-flex my-9 justify-center home-page__pagination"
				v-if="!isLoading && forumCategories.length > 0"
			>
				<Pagination
					:page="filters.page"
					:pageCount="+this.pageForumCategories"
					v-on:pageChange="onPageChange"
				/>
			</div>

			<div v-if="isShowCreatePostModal">
				<CreatePostModal
					v-on:closeModal="closeCreatePostModal"
					:show="isShowCreatePostModal"
				/>
			</div>

			<v-btn
				v-show="isShowCreatePostButton"
				@click="openCreatePostModal"
				bottom
				right
				class="add-post-button"
				fixed
				fab
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>

			<v-btn v-show="isVisible" @click="scrollToTop" bottom right fixed fab>
				<v-icon>mdi-chevron-up</v-icon>
			</v-btn>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import FeaturedPost from '@/components/Post/PostFeaturedPreview'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import CategoryCard from '@/components/Forum/CategoryCard'
import CreatePostModal from '@/components/Modals/CreateForumPostModal.vue'
import Avatar from '@/components/Avatar.vue'
import FilterChipButtons from '@/components/FilterChipButtons'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'
import Filter from '@/mixins/Filter'
import FilterModal from '@/components/Modals/FilterModal'
import _ from 'lodash'

export default {
	name: 'ForumCategoriesPage',
	mixins: [Block, Dwh, Filter],
	components: {
		Avatar,
		CreatePostModal,
		FeaturedPost,
		NewsFeedEmpty,
		CategoryCard,
		Pagination,
		PageBlocked,
		FilterChipButtons,
		FilterModal,
	},

	methods: {
		...mapActions('forum', ['fetchForumCategories']),

		toggleVisibility() {
			this.isVisible = window.scrollY > 1000
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		},
		checkScreenWidth() {
			this.isShowCreatePostButton = window.innerWidth >= 1264
		},
		openCreatePostModal() {
			this.isShowCreatePostModal = true
		},
		closeCreatePostModal() {
			this.isShowCreatePostModal = false
		},

		onPageChange(page) {
			// if (this.filters.page !== page) {
			// 	const params = {
			// 		filter: this.filters.filter,
			// 		chapter_id: this.filters.groups,
			// 		search: this.filters.search,
			// 		page: page,
			// 	}
			// 	this.filters.page = page
			// 	const queryString = this.formatFilters(params)
			// 	this.getCategories(queryString)
			// }
		},
	},

	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			this.fetchForumCategories(this.requestQuery)
			this.sendTrigger({
				category: 'Content',
				action: 'view_category',
				module: 'Forums',
			})
		}
	},
	mounted() {
		window.addEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth)
	},

	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('forum', ['forumCategories', 'isLoading', 'pageForumCategories']),
	},

	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			isVisible: false,
			isShowCreatePostButton: true,
			isShowCreatePostModal: false,
			pageBlockedName: 'forums',
		}
	},
}
</script>

<style lang="scss">
.categories-page {
	background: #f1f1f1 !important;
	max-width: 600px;
	width: 100%;

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}

	&__button_box {
		display: flex;
		gap: 12px;
	}

	&__btn-filters {
		color: var(--chip-text-normal) !important;
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		letter-spacing: 0.36px;
		background-color: var(--chip-normal-background) !important;
		border-radius: 15px;
		box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
		text-transform: capitalize !important;
		align-items: center;

		&-active {
			background-color: var(--chip-selected-background) !important;
			color: var(--chip-text-selected) !important;
		}
	}

	&__fake-btn-modal {
		&-container {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 54px;
			background: rgb(255, 255, 255);
			border: 1px solid rgb(230, 230, 230);
			border-radius: 10px;
			padding: 20px 15px;
			max-width: 600px;
			cursor: pointer;

			color: rgb(160, 160, 160);
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			letter-spacing: -0.43px;
		}
	}

	@media screen and (max-width: 1264px) {
		&__search {
			max-width: none;
			width: 100%;
		}
		&__fake-btn-modal-container {
			max-width: none;
			width: 100%;
		}
	}

	&__time {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat;
		font-weight: bold;
	}

	.event {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}

		&__filters {
			color: white;
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			letter-spacing: 0.36px;
			margin-top: 20px;
			background: rgb(65, 161, 216) !important;
			border-radius: 15px;
			box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
			text-transform: capitalize !important;
			align-items: center;
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
			}
		}
	}
}

@media screen and (max-width: 1264px) {
	.page-container {
		max-width: 600px;
	}
}
</style>
